<template lang="pug">
  
div
  div(v-if="hasEnhancedMemoryCookieStatuses" :class="emcsClasses")
    MSparklesIcon(v-if="audit.aiQuestionResults && audit.aiQuestionResults.length" class="mr-1")
    i(v-if="enhancedMemoryCookieStatus && enhancedMemoryCookieStatus.source === 'LOCAL_PROCESSING'" class="fa fa-check-circle mr-1")
    i(v-else-if="enhancedMemoryCookieStatus && enhancedMemoryCookieStatus.source === 'WEB_UNLOCKER'" class="fa fa-moon-o mr-1")
    | {{ enhancedMemoryCookieStatus && enhancedMemoryCookieStatus.statusReadable }}
  
  div(v-else-if="hasGuidedResult" :class="guidedResultClasses")
    | Guide: {{ audit.injectedResult.template.readableStatus }}
  
  div(v-else :class="moonpullClasses")
    MSparklesIcon(v-if="audit.aiQuestionResults && audit.aiQuestionResults.length" class="mr-1")
    | {{ memoryCookieStatusDisplay }}

</template>

<style lang="scss" scoped>
.badge {
  white-space: break-spaces;
}
.badge-strikethrough {
  text-decoration: line-through;
}
</style>

<script>
import Vue from "vue";
import { computed } from "@vue/composition-api";
export default Vue.extend({
  props: ["audit"],
  setup(props) {
    const { audit } = props;

    const memoryCookieStatusClassMap = {
      IMMEDIATE: "badge-primary",
      CONDITIONAL_ON_CMP: "badge-warning",
      CONDITIONAL_ON_CMP_AND_REFRESH: "badge-warning",
      NO_MEMORY_COOKIE: "badge-danger",
      CLOSED_ADVERTISER: "badge-secondary",
      NOT_AUDITED: "badge-secondary",
      MANUAL_REVIEW: "badge-secondary",
      OTHER: "badge-secondary",
    };

    const baseBadgeClasses = ["badge", "d-block", "mb-1"];

    const hasEnhancedMemoryCookieStatuses = computed(() => {
      return !!audit.enhancedMemoryCookieStatuses?.length;
    });

    const hasGuidedResult = computed(() => {
      return !!audit.injectedResult;
    });

    const moonpullClasses = computed(() => {
      const classes = [...baseBadgeClasses];
      classes.push(memoryCookieStatusClassMap[audit.memoryCookieStatus]);
      return classes;
    });

    const guidedResultClasses = computed(() => {
      const classes = [...baseBadgeClasses];
      classes.push("badge-success"); // Always show badge-success for guided result
      return classes;
    });

    const enhancedMemoryCookieStatus = computed(() => {
      return audit.enhancedMemoryCookieStatuses?.[0];
    });

    const emcsClasses = computed(() => {
      const classes = [...baseBadgeClasses];
      if (enhancedMemoryCookieStatus.value) {
        classes.push(
          memoryCookieStatusClassMap[enhancedMemoryCookieStatus.value.status]
        );
      }
      return classes;
    });

    const memoryCookieStatusDisplay = computed(() => {
      if (
        audit.memoryCookieStatus === "CONDITIONAL_ON_CMP_AND_REFRESH" &&
        audit.batchLink?.postAlpURL
      ) {
        return "Cookie with consent and navigate";
      }
      return audit.memoryCookieStatusReadable;
    });

    return {
      hasEnhancedMemoryCookieStatuses,
      hasGuidedResult,
      moonpullClasses,
      guidedResultClasses,
      enhancedMemoryCookieStatus,
      emcsClasses,
      memoryCookieStatusDisplay,
    };
  },
});
</script>
